import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { IValidationData } from "../../models/dto/validation-data";
import { KuikaHelper } from "./kuika-react-helper";
import { KMainFunctions } from "./main-functions";

declare let window: any;
const confJson = require("../json/conf.json");

export class KuikaAppManager {
  public static addToPageInputVariables(screen: any, paramName: string, val: any) {
    if (!window.kuika) window.kuika = {};
    if (!window.kuika?.navigationScreenInputs) window.kuika.navigationScreenInputs = {};
    window.kuika.navigationScreenInputs[paramName] = val;
  }

  public static increaseServerRequestCount() {
    if (!window.kuika) window.kuika = {};
    if (window.kuika?.serverRequestCount === undefined) window.kuika.serverRequestCount = 0;
    window.kuika.serverRequestCount++;
  }

  public static resetServerRequestCount() {
    if (!window.kuika) window.kuika = {};
    window.kuika.serverRequestCount = 0;
  }

  public static prepareForNavigation() {
    KuikaAppManager.resetServerRequestCount();
    window.kuika.navigationScreenInputs = {} as any;
  }

  static GetBackendUrl(forOnlyInfo = false) {
    if (window._env_ && window._env_.BACKEND_URL) {
      return window._env_.BACKEND_URL;
    }

    let backendUrl = "";

    // JSON case
    if (backendUrl === "" && confJson?.backendUrlOverride?.length > 1) {
      backendUrl = confJson.backendUrlOverride;
      if (!backendUrl.endsWith("/v1/api")) {
        backendUrl = `${backendUrl}/v1/api`;
      }
    }

    // Web component case
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app?.manifest?.appName === confJson.applicationName && app?.manifest?.workspace === confJson?.domainName) {
          if (app?.manifest?.backendUrlOverride?.length && app?.manifest?.backendUrlOverride.length > 0) {
            backendUrl = KuikaAppManager.removeTrailingSlash(app?.manifest?.backendUrlOverride);
            if (!backendUrl.endsWith("/v1/api")) {
              backendUrl = `${backendUrl}/v1/api`;
            }
          } else {
            backendUrl = KuikaAppManager.getBackendUrlFromFullUrl(app?.appConfig?.frontEndUrl);
          }
        }
      });
    }

    if (backendUrl === "") {
      backendUrl = KuikaAppManager.getBackendUrlFromFullUrl(KMainFunctions.windowLocationOrigin);
    }

    if (backendUrl.indexOf("localhost") > -1 && backendUrl.indexOf("https") === 0) {
      const port = this.getPortFromURL(backendUrl);
      if (port !== undefined && port.length > 0) {
        let difference: number = 0;
        if (forOnlyInfo === false) {
          difference = 200;
        }
        const sslPort = (Number(port) + difference).toString();
        backendUrl = backendUrl.replace(port, sslPort);
      }
    }

    return KuikaAppManager.removeTrailingSlash(backendUrl);
  }

  static getPortFromURL(url: string) {
    const regex = /^(http|https):\/\/[^:\/]+(?::(\d+))?/;
    const match = url.match(regex);
    if (match === null || match === undefined) {
      return undefined;
    }
    return match[2] ? match[2] : undefined;
  }

  static IsWebComponent() {
    let result = false;
    // Web component case
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app?.manifest?.appName === confJson.applicationName && app?.manifest?.workspace === confJson?.domainName) {
          result = true;
        }
      });
    }
    return result;
  }

  static GetFrontEndSourceUrl() {
    let result = "";
    // Web component case
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app?.manifest?.appName === confJson.applicationName && app?.manifest?.workspace === confJson?.domainName) {
          result = KuikaAppManager.removeTrailingSlash(app?.appConfig?.frontEndUrl);
        }
      });
    }
    if (result === "") {
      result = KuikaAppManager.GetFrontEndUrl();
    }
    result = KuikaAppManager.removeTrailingSlash(result);
    return result;
  }

  static GetFrontEndUrl() {
    let origin = KMainFunctions.windowLocationOrigin;
    let result = KuikaAppManager.removeTrailingSlash(origin);
    return result;
  }

  public static getBackendUrlFromFullUrl = (baseUrl: string) => {
    baseUrl = KuikaAppManager.removeTrailingSlash(baseUrl);
    if (baseUrl.indexOf("localhost") > -1)
      return `${window.location.protocol === "file:" ? "http:" : window.location.protocol}//localhost:20819/v1/api`;
    let kuikaUrls = ["https://localhost", "https://demo.kuika.com", "https://beta.kuika.com", "https://designerdev.kuika.com", "https://designerdev2.kuika.com", "https://alpha.kuika.com", "https://preprod.kuika.com", "https://platform.kuika.com", "https://izzymobility.kuika.com", "https://idata.kuika.com", "https://alpha.kuika.com", "https://designerdev1.kuika.com","https://test.kuika.com","https://test1.kuika.com","https://test2.kuika.com","https://perftest.kuika.com"];
    if (kuikaUrls.indexOf(baseUrl) > -1) return baseUrl + ":20819/v1/api";
    return KuikaAppManager.getApiUrlFromBaseUrl(baseUrl);
  };

  public static getApiUrlFromBaseUrl = (baseUrl: string) => {
    baseUrl = KuikaAppManager.removeTrailingSlash(baseUrl);
    const re = new RegExp("(.*//)([a-zA-Z0-9-]+)(..*)");
    let result = "";
    const isDesignTime = window.kuika && window.kuika.isDesignTime;
    if (isDesignTime === true || baseUrl.indexOf(".kuika.com/") === -1) {
      // Design, UAT, Prod etc. Env.
      result = baseUrl.replace(re, "$1$2api$3/v1/api");
    } else {
      // Kuika Preview Env (Run)
      result = baseUrl.replace(re, "$1$2$3-api/v1/api");
    }
    return result;
  };

  public static removeTrailingSlash(inputString) {
    if (inputString.endsWith("/")) {
      return inputString.slice(0, -1);
    }
    return inputString;
  }

  public static ApiRequest = async (screen: any, requestPath, vars?: any, httpMethod = "post") => {
    try {
      let backendUrl = KuikaAppManager.GetBackendUrl();
      if (!backendUrl.endsWith("/")) backendUrl += "/";
      const url = backendUrl + requestPath;
      const config: AxiosRequestConfig = {
        headers: {
          // @ts-ignore
          projectHash: "0e761c9227f66f8ec139513bf76cc037c71907a46744fbce529ca32f44be5063" || ""
        }
      };

      if (config && url) {
        KuikaHelper.addExtraHeaderForApiCall(config, url, backendUrl);
      }

      if (httpMethod === "post") {
        const res = await Axios.post<any, AxiosResponse>(url, vars, config);
        return res;
      }
      if (httpMethod === "get") {
        const res = await Axios.get<any, AxiosResponse>(url, config);
        return res;
      }
      if (httpMethod === "put") {
        const res = await Axios.put<any, AxiosResponse>(url, vars, config);
        return res;
      }
      if (httpMethod === "delete") {
        const res = await Axios.delete<any, AxiosResponse>(url, config);
        return res;
      }
    } catch (ex: any) {
      KuikaAppManager.hideSpinner(screen);
      KMainFunctions.exceptionHandler(ex);
      return ex;
    }
  };

  public static showSpinner(screen: any) {
    screen.setState({ spinnerCount: screen.state.spinnerCount + 1 });
  }

  public static hideSpinner(screen: any) {
    screen.setState({ spinnerCount: 0 });
  }

  /**
   * Helper method to calculate and set MFE body height.
   * @param includeMfeLayout - If true, includes MFE layout header/footer heights in the calculation.
   */
  private static calculateMfeBodyHeight(includeMfeLayout: boolean = false): void {
    if (window.kuika.isDesignTime) return;

    const mfeApp = window.document.getElementsByClassName("kuika_mfe_app")[0];
    if (!mfeApp) return;

    const mfeBody = mfeApp.querySelector('[id$="_body"]');
    if (!(mfeBody instanceof HTMLElement)) return;

    // Get master layout header and footer heights
    const masterLayoutHeader = window.document.querySelector('[id$="_layout_header"]');
    const masterLayoutFooter = window.document.querySelector('[id$="_layout_footer"]');
    const masterLayoutHeaderHeight = masterLayoutHeader
      ? parseFloat(window.getComputedStyle(masterLayoutHeader).height) || 0
      : 0;
    const masterLayoutFooterHeight = masterLayoutFooter
      ? parseFloat(window.getComputedStyle(masterLayoutFooter).height) || 0
      : 0;

    // Get MFE header and footer heights (exclude layout headers/footers)
    const mfeHeaders = window.document.querySelectorAll('[id$="_header"]:not([id$="_layout_header"])');
    const mfeFooters = window.document.querySelectorAll('[id$="_footer"]:not([id$="_layout_footer"])');
    let mfeHeaderHeight = 0;
    let mfeFooterHeight = 0;

    mfeHeaders.forEach((header: any) => {
      mfeHeaderHeight += parseFloat(window.getComputedStyle(header).height) || 0;
    });

    mfeFooters.forEach((footer: any) => {
      mfeFooterHeight += parseFloat(window.getComputedStyle(footer).height) || 0;
    });

    let totalHeightToSubtract = masterLayoutHeaderHeight + masterLayoutFooterHeight + mfeHeaderHeight + mfeFooterHeight;

    if (includeMfeLayout) {
      const mfeLayoutHeader = mfeApp.querySelector('[id$="_layout_header"]');
      const mfeLayoutFooter = mfeApp.querySelector('[id$="_layout_footer"]');
      const mfeLayoutHeaderHeight = mfeLayoutHeader
        ? parseFloat(window.getComputedStyle(mfeLayoutHeader).height) || 0
        : 0;
      const mfeLayoutFooterHeight = mfeLayoutFooter
        ? parseFloat(window.getComputedStyle(mfeLayoutFooter).height) || 0
        : 0;
      totalHeightToSubtract += mfeLayoutHeaderHeight + mfeLayoutFooterHeight;
    }

    const calculatedHeight = `calc(100vh - ${totalHeightToSubtract + 32}px)`;
    mfeBody.style.height = "auto";
    mfeBody.style.minHeight = calculatedHeight;
  }

  public static calculateAndSetBodyHeight(screenName: string, masterScreenName: string) {
    if (masterScreenName) {
      masterScreenName = masterScreenName.replace(/\s+/g, "_");
    }
    const hasMaster = masterScreenName && masterScreenName !== "";
    setTimeout(() => {
      const body = window.document.getElementById(`${screenName}_body`);
      if (!body) return;
      let headerHeight: number = 0;
      let footerHeight: number = 0;

      const header = window.document.getElementById(`${screenName}_header`);
      const footer = window.document.getElementById(`${screenName}_footer`);
      const isHeaderTransparent =
        header &&
        header.style &&
        (header.style.backgroundColor === "transparent" || header.style.backgroundColor === "rgba(0, 0, 0, 0)");
      const isFooterTransparent =
        footer &&
        footer.style &&
        (footer.style.backgroundColor === "transparent" ||
          footer.style.backgroundColor === "rgba(0, 0, 0, 0)" ||
          !footer.style.backgroundColor);
      const layout_header = window.document.getElementById(`${masterScreenName.replace("_screen", "")}_layout_header`);
      const layout_footer = window.document.getElementById(`${masterScreenName.replace("_screen", "")}_layout_footer`);
      const masterRootDI = window.document.getElementById("masterRootDI");

      if (masterRootDI && hasMaster) {
        let headerHeight = layout_header ? parseFloat(window.getComputedStyle(layout_header).height) : 0;
        let footerHeight = layout_footer ? parseFloat(window.getComputedStyle(layout_footer).height) : 0;

        masterRootDI.style.height = `calc(100vh - ${headerHeight + footerHeight}px)`;
      }
      if (!header && !footer) {
        const layout_header = window.document.getElementById(
          `${masterScreenName.replace("_screen", "")}_layout_header`
        );
        const layout_footer = window.document.getElementById(
          `${masterScreenName.replace("_screen", "")}_layout_footer`
        );
        if (layout_header) {
          const headerStyles = window.getComputedStyle(layout_header);
          const headerPaddingTop = parseFloat(headerStyles.paddingTop) || 0;
          const headerPaddingBottom = parseFloat(headerStyles.paddingBottom) || 0;
          headerHeight = parseFloat(headerStyles.height) + headerPaddingTop + headerPaddingBottom;
        }

        if (layout_footer) {
          const footerStyles = window.getComputedStyle(layout_footer);
          const footerPaddingTop = parseFloat(footerStyles.paddingTop) || 0;
          const footerPaddingBottom = parseFloat(footerStyles.paddingBottom) || 0;
          footerHeight = parseFloat(footerStyles.height) + footerPaddingTop + footerPaddingBottom;
        }
      } else {
        if (header) {
          const headerStyles = window.getComputedStyle(header);
          const headerPaddingTop = parseFloat(headerStyles.paddingTop) || 0;
          const headerPaddingBottom = parseFloat(headerStyles.paddingBottom) || 0;
          headerHeight = parseFloat(headerStyles.height) + headerPaddingTop + headerPaddingBottom;
        }

        if (footer) {
          const footerStyles = window.getComputedStyle(footer);
          const footerPaddingTop = parseFloat(footerStyles.paddingTop) || 0;
          const footerPaddingBottom = parseFloat(footerStyles.paddingBottom) || 0;
          footerHeight = parseFloat(footerStyles.height) + footerPaddingTop + footerPaddingBottom;
        }
      }

      const layout_right = window.document.getElementById(`${masterScreenName.replace("_screen", "")}_layout_right`);
      const layout_left = window.document.getElementById(`${masterScreenName.replace("_screen", "")}_layout_left`);
      const layout_left_rect = layout_left ? layout_left.getBoundingClientRect() : undefined;
      const layout_right_rect = layout_right ? layout_right.getBoundingClientRect() : undefined;
      const layout_footer_rect = layout_footer ? layout_footer.getBoundingClientRect() : undefined;
      const isChildOfMasterRootDI = (element: HTMLElement) => {
        if (!element) return false;
        if (element.id === "masterRootDI") return true;
        return isChildOfMasterRootDI(element.parentElement);
      };
      const isHeaderExistInMasterDI = isChildOfMasterRootDI(header);
      const isFooterExistInMasterDI = isChildOfMasterRootDI(footer);
      if (header && header.style && isHeaderExistInMasterDI) {
        const leftAndRightLayoutsWidth = layout_left_rect?.width + layout_right_rect?.width;
        header.style.zIndex = 1;
        header.style.width = leftAndRightLayoutsWidth > 0 ? `calc(100% - ${leftAndRightLayoutsWidth}px)` : "100%";
        if (layout_right && layout_right.style) {
          layout_right.style.zIndex = 1;
        }
      }

      if (footer && footer.style && isFooterExistInMasterDI) {
        const leftAndRightLayoutsWidth = layout_left_rect?.width + layout_right_rect?.width;
        footer.style.zIndex = 1;
        footer.style.width = leftAndRightLayoutsWidth > 0 ? `calc(100% - ${leftAndRightLayoutsWidth}px)` : "100%";
        footer.style.bottom = layout_footer && layout_footer_rect ? `${layout_footer_rect.height}px` : "0px";
        if (layout_right && layout_right.style) {
          layout_right.style.zIndex = 1;
        }
      }

      if (body && body.style) {
        const parentModal = body.closest(".ant-modal-body") as HTMLElement | null;
        const parentFloatPanel = body.closest(".kuika-float-panel-content");
        const parentDrawer = body.closest(".ant-drawer-body");
        const drawerWidth = parentDrawer ? parseFloat(window.getComputedStyle(parentDrawer).width) : 0;
        if (parentModal) {
          const modalComputedStyle = window.getComputedStyle(parentModal);
          const modalPadding = parseFloat(modalComputedStyle.padding);
          const inlineHeight = parentModal.style.height;
          const isPercentageHeight = inlineHeight && inlineHeight.includes("%");

          if (isPercentageHeight) {
            const percentValue = parseFloat(inlineHeight);
            body.style.height = `calc(${percentValue}vh - ${headerHeight + footerHeight + modalPadding}px)`;
            body.style.minHeight = `calc(${percentValue}vh - ${headerHeight + footerHeight + modalPadding}px)`;
            body.style.maxHeight = `calc(${percentValue}vh - ${headerHeight + footerHeight + modalPadding}px)`;
          } else {
            const modalHeight = parseFloat(modalComputedStyle.height);
            if (modalHeight > 0) {
              body.style.height = `calc(${modalHeight}px - ${headerHeight + footerHeight + modalPadding}px)`;
              body.style.minHeight = `calc(${modalHeight}px - ${headerHeight + footerHeight + modalPadding}px)`;
              body.style.maxHeight = `calc(${modalHeight}px - ${headerHeight + footerHeight + modalPadding}px)`;
            }
          }
          body.style.overflowY = "auto";
          const modalContent = parentModal.closest(".ant-modal-content") as HTMLElement | null;
          if (modalContent && body.style.backgroundColor) {
            modalContent.style.backgroundColor = body.style.backgroundColor;
          }
          if (layout_footer && parentModal.clientHeight) {
            let topValue = parentModal.clientHeight;
            if (layout_header && layout_header.style && layout_header.style.height) {
              topValue -= parseInt(layout_header.style.height) + 20;
            } else {
              topValue -= 60;
            }
            layout_footer.style.position = "absolute";
            layout_footer.style.top = `${topValue}px`;
            layout_footer.style.width = "100%";
          }
        } else if (parentFloatPanel) {
          const floatPanelComputedStyle = window.getComputedStyle(parentFloatPanel as Element);
          const floatPanelHeight = parseFloat(floatPanelComputedStyle.height);
          const floatPanelPadding = parseFloat(floatPanelComputedStyle.padding);
          const floatPanelHeader = parentFloatPanel.closest(".kuika-float-panel-header");
          const floatPanelHeaderHeight = floatPanelHeader
            ? parseFloat(window.getComputedStyle(floatPanelHeader).height)
            : 0;
          body.style.height = `calc(${floatPanelHeight}px - ${
            headerHeight + footerHeight + floatPanelPadding + floatPanelHeaderHeight
          }px)`;
          body.style.minHeight = `calc(${floatPanelHeight}px - ${
            headerHeight + footerHeight + floatPanelPadding + floatPanelHeaderHeight
          }px)`;
          body.style.maxHeight = `calc(${floatPanelHeight}px - ${
            headerHeight + footerHeight + floatPanelPadding + floatPanelHeaderHeight
          }px)`;
          body.style.overflowY = "auto";
        } else if (isChildOfMasterRootDI(body)) {
          if (footer && footer.style) {
            footer.style.bottom = "0px";

            if (!parentDrawer) {
              footer.style.width = "100%";
              if (isFooterTransparent) {
                footer.style.position = "fixed";
              } else {
                footer.style.position = "sticky";
              }
            } else {
              footer.style.width = `${drawerWidth}px`;
              footer.style.position = isFooterTransparent ? "fixed" : "sticky";
            }
          }
          if (header && header.style && isHeaderTransparent) {
            if (!parentDrawer) {
              header.style.width = "100%";
            } else {
              header.style.width = `${drawerWidth}px`;
            }
            header.style.position = "fixed";
            header.style.top = "0px";
            const currentBodyPaddingTop = parseFloat(window.getComputedStyle(body).paddingTop) || 0;
            if (!parentDrawer) {
              body.style.paddingTop = `${currentBodyPaddingTop + headerHeight}px`;
            } else {
              body.style.paddingTop = `${headerHeight}px`;
            }
          }
          body.style.height = "";
          body.style.minHeight = "";
          body.style.maxHeight = "";
          let currentElement = body;
          const rootDiWrapper = document.getElementById("masterRootDI_wrapper");
          if (rootDiWrapper && body.style) {
            rootDiWrapper.style.backgroundColor = body.style.backgroundColor;
          }
          while (currentElement && currentElement.id !== "masterRootDI") {
            currentElement.style.height = "100%";
            currentElement = currentElement.parentElement;
          }

          KuikaAppManager.calculateMfeBodyHeight(true);
          return;
        } else {
          const bodyPaddingTop = parseFloat(window.getComputedStyle(body).paddingTop) || 0;
          const bodyPaddingBottom = parseFloat(window.getComputedStyle(body).paddingBottom) || 0;
          let heightNum = headerHeight + bodyPaddingTop + bodyPaddingBottom;
          if (footer && !isFooterTransparent) {
            heightNum += footerHeight;
          }
          const heightStr = parentDrawer
            ? `calc(100vh - ${headerHeight + footerHeight}px)`
            : `calc(100vh - ${heightNum}px)`;
          body.style.height = heightStr;
          body.style.minHeight = heightStr;
          body.style.maxHeight = heightStr;
          body.style.overflow = "auto";
          if (header && header.style && isHeaderTransparent) {
            header.style.top = "0px";
            if (!parentDrawer) {
              header.style.width = "100%";
            } else {
              header.style.width = `${drawerWidth}px`;
            }
            header.style.position = "fixed";
            header.style.zIndex = 1;
            const currentBodyPaddingTop = parseFloat(window.getComputedStyle(body).paddingTop) || 0;
            if (!parentDrawer) {
              body.style.paddingTop = `${currentBodyPaddingTop + headerHeight}px`;
            } else {
              body.style.paddingTop = `${headerHeight}px`;
            }
          }
          if (footer && footer.style) {
            footer.style.bottom = "0px";
            if (!parentDrawer) {
              footer.style.width = "100%";
            } else {
              footer.style.width = `${drawerWidth}px`;
            }
            if (isFooterTransparent) {
              footer.style.position = "fixed";
              footer.style.zIndex = 1;
              const currentBodyPaddingBottom = parseFloat(window.getComputedStyle(body).paddingBottom) || 0;
              if (!parentDrawer) {
                body.style.paddingBottom = `${currentBodyPaddingBottom + footerHeight}px`;
              } else {
                body.style.paddingBottom = `${footerHeight}px`;
              }
            } else {
              footer.style.position = "sticky";
            }
          }

          KuikaAppManager.calculateMfeBodyHeight(false);
        }
      }
    }, 1);
  }

  public static handleValidations(screen: any, data: IValidationData[], callback?: () => void): boolean {
    const validationsErrorsToRemove = data.filter(
      (x) => x.condition === false || (x.condition === true && x.isValid === true)
    );
    const validationsErrorsToShow = data.filter((x) => x.condition === true && x.isValid === false);
    const hasValidationError = validationsErrorsToShow.length > 0;

    validationsErrorsToRemove.forEach((x) => {
      screen.props.form.setFields([
        {
          name: x.formName,
          errors: []
        }
      ]);
    });

    validationsErrorsToShow.forEach((x) => {
      screen.props.form.setFields([
        {
          name: x.formName,
          errors: [x.message]
        }
      ]);
    });

    if (callback) {
      setTimeout(() => {
        callback();
      }, 100);
    }

    if (hasValidationError) {
      this.hideSpinner(screen);
    }
    return hasValidationError;
  }

  public static isPageInitPrevented(): boolean {
    if (!window?.kuika?.pageInitCallers) return false;
    // TODO:TURENC FURKAN, CAGAN bu bölüm Virtual directoryler için ayrı normal hosting için ayrı test edilmeli!
    const hash = window.location.hash?.substring(2);
    const path = window.location.pathname?.substring(1);
    if (hash && window.kuika.pageInitCallers[hash] !== undefined && window.kuika.pageInitCallers[hash] === false)
      return true;
    if (path && window.kuika.pageInitCallers[path] !== undefined && window.kuika.pageInitCallers[path] === false)
      return true;
    return false;
  }
}
